import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  message,
  Upload,
  Form,
  Modal,
  Tooltip,
  Switch,
  Image,
  Dropdown,
  Avatar,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import DriversStore from "../store/DriversStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";

import config from "../config";
import conf from "../config";

import withRouter from "../withRouter";

import CompanyStore from "../store/CompanyStore";
import DriverAdd from "./DriverAdd";
import DriverListFields from "./Plugins/AddDriver/DriverListFields";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import logoutIcon from "../assets/images/NewDesign/sign-out.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";

const { Dragger } = Upload;
class CompanyDriversList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.companySearch=this.companySearch.bind(this);
    this.onDelete = this.onDelete.bind(this);

    this.driversStore = new DriversStore(this);
    this.companyStore = new CompanyStore(this);

    // console.log(this.context);

    this.state = {
      loading: false,
      companyLoading: false,
      pageSize: 50,
      currentPage: 1,
      offset: 0,
      limit: 50,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      companyId: "",
      companyId_value_label: "",
      showUpload: false,
      openDriverDetailsForm: false,
      driverId: "",
      listDataUpdate: false,
      searchField: "",
      showStatusConfirm: false,
      showStatusLogout: false,
      logOutDriverId: "",

      editData: {},
      openDeleteModal: false,
      deleteData: {},
    };

    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },

        {
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "uploadexcel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (this.driversStore?.drivers?.length == 0) return;
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));

        var getData = {
          companyId: this.state.companyId,
          searchField: "",
          colList: result,
        };

        if (val.key == "excel") {
          this.driversStore.exportExcel(getData);
        }
      },
    };

    this.columns = [
      {
        title: context.translate("_DRIVER_ID_"),

        dataIndex: "driverId",
        width: 50,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DRIVER_NAME_"),

        dataIndex: "name",
        width: 80,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("companydriverslist") &&
                  this.onEdit(record);
              }}
            >
              {value}
            </Link>
          );
        },
      },
      {
        title: context.translate("_DRIVER_NAME_ARABIC_"),

        dataIndex: "driverNameArabic",
        width: 80,
        ellipsis: {
          showTitle: true,
        },
      },
      // {
      //   title: context.translate("_ASSIGN_ASSET_"),
      //   dataIndex: "vehicleNo",
      //   width: "15%",
      // },
      {
        title: context.translate("_LICENSE_NUMBER_"),
        dataIndex: "licensenumber",
        width: 60,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_LICENSE_NUMBER_ARABIC_"),
        dataIndex: "licenseNoArabic",
        width: 80,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DRIVER_DRIVERLIST_MOBILE_"),
        dataIndex: "mobileno",
        width: 60,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_TAG_ID_"),
        dataIndex: "DriverTagid",
        width: 40,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DRIVER_DRIVERDETAIL_LICENSEEXPIRY_"),

        dataIndex: "expireDate",
        width: 60,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: "right",
        align: "center",
        width: 40,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          // console.log(record)
          return (
            <>
              <Space>
                <Tooltip
                  title={
                    record.status == "1"
                      ? context.translate("_ACTIVE_")
                      : context.translate(
                          "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                        )
                  }
                  placement="top"
                  color={
                    record.status == "1"
                      ? config.activeColor
                      : config.inActiveColor
                  }
                >
                  {this.props.canUpdate("companydriverslist") && (
                    <Switch
                      className="switch-btn"
                      size="small"
                      // className="form-offlineAlerts"
                      checked={Number(record.status)}
                      onChange={async (val) => {
                        console.log(val);
                        this.setState({ driverId: record.driverId });
                        this.setState({ isActive: val });
                        this.setState({ showStatusConfirm: true }); // open modal
                      }}
                      // defaultChecked
                    />
                  )}
                </Tooltip>
                {this.props.canDelete("companydriverslist") && (
                  <Tooltip
                    title={this.context.translate(
                      "_FLEET_DRIVER_DRIVERLIST_DELETE_"
                    )}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}

                <Dropdown
                  // overlayClassName="export-dropdown"
                  menu={this.actionColumn}
                  trigger={["click"]}
                  style={{ cursor: "pointer", width: "15px" }}
                >
                  <Image
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit Driver Details"
                    title={context.translate(
                      "_FLEET_DRIVER_DRIVERLIST_EDIT_"
                    )}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}

                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <Tooltip
                      // title="Delete Driver"
                      title={context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_DELETE_"
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}

                {/* <Tooltip
                  title={context.translate("_FLEET_LOGOUT_")}
                  color={config.tooltipColorEdit}
                >
                  <span>
                    <i
                      class="bi bi-power"
                      onClick={() => {
                        this.setState({
                          showStatusLogout: true,
                          logOutDriverId: record.driverId,
                        });
                      }}
                    ></i>
                  </span>
                </Tooltip> */}
              </Space>
            </>
          );
        },
      },
    ];

    this.waslMenuList = {
      items: [
        {
          label: (
            <Link
              to={"/wasldriverlist"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                textDecoration: "none",
              }}
            >
              {" "}
              <PlusOutlined
                style={{ height: "14px", width: "14px", borderRadius: "0px" }}
              />
              {context.translate("_WASL_")}
            </Link>
          ),
          key: "wasl",
        },
      ],
    };
  }

  async componentDidUpdate(prvProp, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const driverStates = this.context.viewStateStore.driverStateObj;
      if (driverStates.companyId !== "") {
        const singleData = await this.companyStore.getCompanyDataById(
          driverStates.companyId
        );
        await this.setState({
          companyId_value_label: singleData,
          searchField: driverStates.searchText,
          companyId: driverStates.companyId,
        });
        await this.driversStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          searchField: driverStates.searchText,
          companyId: driverStates.companyId,
          isadmin: this.props.getUserData().isadmin,
        });
        await this.setState({ loadList: 1, companyLoading: false });
        await this.setState({ loadList: 1 });
      }

      await this.setState({ listDataUpdate: false });
      console.log(driverStates.companyId);
    }
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      //  console.log(this.state.companyId)
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ searchField: "" });

    if (this.context.viewStateStore.driverStateObj.showWaslList) {
      const driverStates = this.context.viewStateStore.driverStateObj;
      if (driverStates.companyId !== "") {
        const singleData = await this.companyStore.getCompanyDataById(
          driverStates.companyId
        );
        await this.setState({
          companyId_value_label: singleData,
          searchField: driverStates.searchText,
          companyId: driverStates.companyId,
        });
        await this.driversStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          searchField: driverStates.searchText,
          companyId: driverStates.companyId,
          isadmin: this.props.getUserData().isadmin,
        });
      }
    }

    this.actionColumn = {
      items: [
        this.props.canUpdate("companydriverslist") && {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {this.context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },

        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() =>
                this.setState({
                  showStatusLogout: true,
                  logOutDriverId: this.state.editData?.driverId,
                })
              }
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={logoutIcon}
              ></Avatar>
              {this.context.translate("_FLEET_LOGOUT_")}
            </div>
          ),
          key: "logout",
        },
      ],
    };
    // await this.passengerStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
    //this.handleSearch();
    // this.setState({loadList:1})
  }
  onEdit = async (record) => {
    console.log(record.driverId);
    const driverId = record.driverId;
    if (driverId) {
      await this.context.viewStateStore.setDriverState({
        companyId: record.companyId,
        searchText: this.state.searchField,
      });
      await this.setState({ driverId: driverId });
      await this.setState({ openDriverDetailsForm: true });
      // await this.props.navigate("/driveradd/" + driverId);
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  confirmStatus = async (status) => {
    const data = {};

    data.driverId = this.state.driverId;
    data.activeStatus = this.state.isActive === true ? 1 : 0;

    await this.driversStore.updateStatus(data);

    console.log(data);

    this.setState({ showStatusConfirm: false });
    await this.handleSearch();
    //  await this.setState({ loading: true });
    //   await this.driversStore.loadData({ offset: 0, limit: 50 });
    // await this.setState({ loading: false });
  };

  confirmLogoutStatus = async () => {
    const data = {
      driverId: this.state.logOutDriverId,
    };
    console.log(data);
    const response = await this.driversStore.logoutDriver(data);
    if (response?.success === "S") {
      message.success(response.message);
      this.setState({ showStatusLogout: false });
      // this.props.navigate("/companydriverslist");
    } else {
      message.error(response.message);
    }
  };

  async handleChange(comp) {
    console.log(comp);
    await this.setState({
      companyId: comp.value,
      companyLoading: true,
      pageSize: 50,
      currentPage: 1,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyId_value_label: singleData });

    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.driversStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
    });
    await this.setState({ loadList: 1, companyLoading: false });
  }

  async inputSearchButton() {
    if (this.state.companyId && this.state.searchField.length > 0) {
      await this.driversStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
      });
    }
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {
    console.log(record, "reco");
    const response = await this.driversStore.deleteRecord({
      driverId: record.driverId,
      userId: 1,
    });
    // console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  searchInput = async (e) => {
    const value = e.target.value;
    console.log(value);
    await this.setState({ searchField: value });
    if (value.length > 3) {
      await this.driversStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1, companyLoading: false });
    } else if (value.length === 0) {
      await this.driversStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        // searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({
        loadList: 1,
        companyLoading: false,
        currentPage: 1,
      });
    }
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    console.log(fileinfo);

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      excelFile: this.state.excelFile,
    };
    if (data.excelFile) {
      const resp = await this.driversStore.addDriverByExcel(data);

      if (resp?.success == "S") {
        console.log(resp.data.length > 0);
        message.success(resp.message);

        this.setState({ showUpload: false });
        this.setState({ excelFile: "" });
        this.handleSearch();

        this.setState({ showUpload: false });
        this.formRef.current?.resetFields();
      } else {
        message.error(resp.message);
      }
    } else {
      message.error("Please Upload Excel File");
    }
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openDriverDetailsForm: false });
      await this.handleSearch();
      // this.props.navigate("/companyuserlist");
    } else if (resp.success === "F5000") {
      resp.errors.map((value) => {
        message.error(this.context.translate(value["username"]));

        // console.log(this.context.translate(value["driver"]),value["driver"])
      });
    }
  };

  validateFile = (file) => {
    this.setState({ fileList: file });
    console.log(file);

    const maxSize = conf.UploadExcelSize;
    if (file.size > maxSize) {
      message.error("File size must be less than or equal to 1MB");
      return false;
    }
    return true;
  };

  closeModal = () => {
    this.setState({ openDriverDetailsForm: false, driverId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.driversStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
      });
    }
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
             
              <div className="heading">
                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_TITLE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
              
                <Tooltip
                  placement="left"
                  // title="Add"
                  title={this.context.translate(
                    "_FLEET_DRIVER_DRIVERLIST_ADDBTN_"
                  )}
                  color={config.primaryColor}
                >
                  <Button
                    type="primary"
                    className="addButton"
                    icon={<PlusOutlined />}
                    onClick={() =>
                      this.setState({
                        openDriverDetailsForm: true,
                        driverId: "",
                      })
                    }
                  ></Button>
                </Tooltip>

                {(Number(this.props.getUserData().isadmin) === -1 ||
                  Number(this.props.getUserData().isadmin) === 3) && (
                  <DriverListFields
                    companyId={this.state.companyId}
                    searchField={this.state.searchField}
                  />
                )}

                <Button
                  disabled={
                    this.driversStore?.drivers?.length > 0 ? false : true
                  }
                  className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  onClick={(val) => {
                    let result = [];
                    if (true) {
                      this.columns.map((obj) => result.push(obj.dataIndex));

                      //  console.log(result.toString())

                      var getData = {
                        companyId: this.state.companyId,

                        searchField: "",
                        colList: result,
                      };
                      console.log(getData);
                      if (val) {
                        // console.log("afd")
                        this.driversStore.exportExcel(getData);
                      }
                    }
                  }}
                >
                  <DownloadOutlined />
                  
                  {this.context.translate("_EXPORT_")}
                </Button>

                <Tooltip
                  // title="Upload"
                  title={this.context.translate("_UPLOAD_")}
                  color={config.tooltipColorEdit}
                >
                  <Button
                    className="uploadBtn"
                    type={config.uploadBoxType}
                    onClick={() => this.setState({ showUpload: true })}
                  >
                    <UploadOutlined />
                  </Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.companyId_value_label
                      ? this.state.companyId_value_label
                      : null
                  }
                  onChange={(value) => {
                    this.handleChange(value);
                  }}
                  // allowClear={true}
                  style={{ width: 200 }}
                  disabled={this.state.companyLoading}
                />
                <Input
                  // placeholder="Search by Driver Name,Mobile No"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_DRIVER_NAME_MOBILE_"
                  )}
                  value={
                    this.state.searchField !== ""
                      ? this.state.searchField
                      : null
                  }
                  style={{ width: 300, borderRadius: "25px" }}
                  onChange={async (e) => {
                    await this.searchInput(e);
                  }}
                />
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.inputSearchButton();
                    console.log("asdf");
                  }}
                /> */}
              </Space>
            </Col>

            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                {(Number(this.props.getUserData().isadmin) == -1 ||
                  Number(this.props.getUserData().isadmin) == 3) && (
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.waslMenuList}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "20px",
                      }}
                      src={kebabIcon}
                    ></Image>
                  </Dropdown>
                )}

                <Tooltip
                  title={this.context.translate("_UPLOAD_")}
                  placement="bottom"
                >
                  <Button
                    className="uploadExcelButton"
                    onClick={() => this.setState({ showUpload: true })}
                  >
                    <Image
                      style={{
                        height: 18,
                      }}
                      src={uploadIcon}
                    />
                  </Button>
                </Tooltip>

                <Tooltip
                  title={this.context.translate("_DOWNLOAD_")}
                  placement="bottom"
                >
                  <span>
                    <Button
                      className={"downloadExcelButton"}
                      disabled={
                        this.driversStore?.drivers?.length > 0 ? false : true
                      }
                      onClick={(val) => {
                        let result = [];
                        if (true) {
                          this.columns.map((obj) => result.push(obj.dataIndex));

                          var getData = {
                            companyId: this.state.companyId,
                            searchField: this.state.searchField,
                            colList: result,
                          };

                          if (val) {
                            this.driversStore.exportExcel(getData);
                          }
                        }
                      }}
                    >
                      <Image
                        style={{
                          height: 18,
                          width: "auto",
                        }}
                        src={downloadIcon}
                      />
                    </Button>
                  </span>
                </Tooltip>

                {this.props.canCreate("companydriverslist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({
                        openDriverDetailsForm: true,
                        driverId: "",
                      })
                    }
                  >
                    <Image
                      style={{
                        marginInlineEnd: "5px",
                        width: 13,
                      }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.driversStore?.total}
            columns={this.columns}
            dataSource={this.driversStore?.drivers}
            loading={this.driversStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.showUpload && (
            <>
              <Drawer
                className="uploadExcelDrawer"
                width={716}
                closeIcon={false}
                open={this.state.showUpload}
                placement={
                  this.context.locale.language === "english" ? "right" : "left"
                }
                footer={false}
                title={
                  <div className="uploadExcelTitle">
                    <Image
                      style={{ height: "60px" }}
                      src={UploadTitleIcon}
                    ></Image>
                    <span>
                      {" "}
                      {this.context.translate("_UPLOAD_EXCEL_TITLE_")}
                    </span>
                  </div>
                }
                maskClosable={false}
                onOk={() => this.setState({ showUpload: false })}
                onCancel={() =>
                  this.setState({
                    showUpload: false,
                    excelFile: "",
                  })
                }
              >
                <Form
                  name="excelimport"
                  layout="vertical"
                  onFinish={this.onExcelSubmit}
                  style={{ margin: "16px 0px" }}
                >
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      className="uploadCompany"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[{ required: true }]}
                      required={false}
                    >
                      <CompanyAutocomplete
                        onChange={(companyId) => {
                          this.setState({ companyId: companyId.value });
                        }}
                      />
                    </Form.Item>
                  )}
                  <Dragger
                    onRemove={() =>
                      this.setState({ excelFile: "", fileList: [] })
                    }
                    name="excelFile"
                    action={
                      // config.baseURL + "/index.php?c=company&a=fileupload"
                      config.baseURL + this.driversStore.uploadExcelUrl
                    }
                    listType="text"
                    data={{
                      fileType: "accountimport",
                      fieldName: "excelFile",
                    }}
                    onChange={this.getUploadData}
                    beforeUpload={(file) => this.validateFile(file)}
                    maxCount={1}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                      }}
                    >
                      <div>
                        <Image
                          style={{ width: "90px" }}
                          src={uploadOutlined}
                        ></Image>
                      </div>
                      <div className="uploadFileText">
                        <span>
                          {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                        </span>
                        <p>
                          {this.context.translate("_UPLOAD_TEXT_")}{" "}
                          <span
                            style={{
                              color: "var(--Blue-6, #1890FF)",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                          >
                            {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                          </span>
                          {this.context.translate("_UPLOAD_TEXT_2_")}
                        </p>
                      </div>
                    </div>
                  </Dragger>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      textAlign: "center",
                      marginTop: "16px",
                    }}
                  >
                    <div className="sampleDownload">
                      <span>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                      <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                      <Button onClick={() => this.driversStore.sampleExcel()}>
                        <Image src={sampleDownloadIcon}></Image>
                        <span style={{ color: "#2563EB", fontSize: "14px" }}>
                          {" "}
                          {this.context.translate("_SAMPLE_DOWNLOAD_")}
                        </span>
                      </Button>
                    </div>

                    <div className="sampleUpload">
                      <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                      <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                      <Button>
                        <Image src={sampleUploadIcon}></Image>
                        <span style={{ color: "#2563EB", fontSize: "14px" }}>
                          {this.context.translate("_SAMPLE_UPLOAD_")}
                        </span>{" "}
                      </Button>
                    </div>
                  </div>

                  <Space className="uploadFooter">
                    <Button
                      className="uploadCancelButton"
                      onClick={() =>
                        this.setState({
                          showUpload: false,
                          excelFile: "",
                        })
                      }
                    >
                      {this.context.translate(
                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                      )}
                    </Button>
                    <Button
                      htmlType="submit"
                      className="uploadButton"
                      // onClick={() => this.onExcelSubmit()}
                    >
                      {this.context.translate("_UPLOAD_")}
                    </Button>
                  </Space>
                </Form>
              </Drawer>{" "}
            </>
          )}
        </div>

        {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_CONFIRM_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showStatusConfirm: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              {this.state.isActive === true ? (
                <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
              ) : (
                <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
              )}
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showStatusConfirm: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.confirmStatus()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}
        {this.state.openDriverDetailsForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //
          //   // title="Driver Details"
          //   title={this.context.translate("_FLEET_DRIVER_DRIVERDETAIL_TITLE_")}
          //   centered
          //   visible={this.state.openDriverDetailsForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openDriverDetailsForm: false, driverId: "" });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openDriverDetailsForm}
            placement={
              this.context.locale.language === "english" ? "right" : "left"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FLEET_DRIVER_DRIVERDETAIL_TITLE_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openDriverDetailsForm: false })}
            onCancel={() =>
              this.setState({ openDriverDetailsForm: false, driverId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <DriverAdd
                driverId={this.state.driverId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.showStatusLogout && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_CONFIRM_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showStatusLogout: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusLogout}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              <p>{this.context.translate("_LOGOUT_STATUS_")}</p>
            </div>
            <div className="confirmStatusButtons">
              <Button
                className="confirmStatusCancelButton"
                onClick={() => this.setState({ showStatusLogout: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.confirmLogoutStatus()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
CompanyDriversList.contextType = StoreContext;
export default observer(withRouter(CompanyDriversList));
